import { createFileRoute, Outlet } from "@tanstack/react-router";
import { zodValidator } from "@tanstack/zod-adapter";
import { z } from "zod";

const searchSchema = z.object({
  events: z.coerce.boolean().optional(),
  nodeId: z.string().optional(),
  edgeId: z.string().optional(),
  syncId: z.string().optional(),
  addProjectSources: z.coerce.boolean().optional(),
});

export const Route = createFileRoute("/_secure/projects/$projectId")({
  validateSearch: zodValidator(searchSchema),
  component: RouteComponent,
});

function RouteComponent() {
  return <Outlet />;
}
